import React from 'react'
import RegistrationForm from '../components/page-component/RegistrationForm'

export default function Register() {
  return (
    <RegistrationForm/>
  )
}
